import { render, staticRenderFns } from "./DomesticWorker.vue?vue&type=template&id=034bcb28&"
import script from "./DomesticWorker.vue?vue&type=script&lang=js&"
export * from "./DomesticWorker.vue?vue&type=script&lang=js&"
import style0 from "./DomesticWorker.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "DomesticWorker.vue"
export default component.exports